import { z } from 'zod'

export const AppPassword = z.object({
  id: z.number(),
  name: z.string(),
  created_at: z.string(),
  last_used_at: z.string().nullish()
})

export type AppPassword = z.infer<typeof AppPassword>

export const AppPasswordListResponse = z.object({
  app_passwords: z.array(AppPassword)
})

export type AppPasswordListResponse = z.infer<typeof AppPasswordListResponse>

export const CreateAppPasswordRequest = z.object({
  name: z.string().max(50)
})

export type CreateAppPasswordRequest = z.infer<typeof CreateAppPasswordRequest>

// The password is in this response only; the server cannot show it again.
export const CreateAppPasswordResponse = z.object({
  id: z.number(),
  name: z.string(),
  password: z.string(),
  created_at: z.string()
})

export type CreateAppPasswordResponse = z.infer<typeof CreateAppPasswordResponse>
